import { SVGProps } from 'react';

const ZoneMove = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 200 200"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.5,
        }}
        {...props}
    >
        <g transform="matrix(1,0,0,1,-3346.03,-0.790589)">
            <g id="Move_Player" transform="matrix(1,0,0,1,3346.03,0.790589)">
                <g id="Move" transform="matrix(3.01325,0,0,2.91007,-3584.86,-353.075)">
                    <g>
                        <g transform="matrix(0.898807,0,0,1.08957,128.63,-4.41302)">
                            <path d="M1185,174L1233,133" fill="none" strokeWidth={2} />
                        </g>
                        <g transform="matrix(0.250437,0,0,0.286678,294.42,119.617)">
                            <ellipse cx="3763.18" cy="72.844" rx="67.5" ry="47.947" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ZoneMove;
